import React, { useState, createContext, useContext } from 'react';
export type Language = 'en' | 'pa' | 'fr';
type LanguageContextType = {
  language: Language;
  setLanguage: (language: Language) => void;
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [language, setLanguage] = useState<Language>('en');
  return <LanguageContext.Provider value={{
    language,
    setLanguage
  }} data-id="element-793">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};